import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import  { useRef,useEffect,useState } from "react";
import {CircularProgress,Box, Typography, Modal, Button, TextField, InputLabel, Select, MenuItem, FormControl, List, ListItem, ListItemText} from '@mui/material';
import { Link } from 'react-router-dom';


function ProcessingModal(props: any) {
    const [isOpen, setIsOpen] = useState(false);
    const [scroll, setScroll] = useState<DialogProps['scroll']>('paper');

    const modalStyle = {
        position: 'absolute' as 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-5%, -60%)',
        width: '40%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      };

      function handleOpen() {
        setIsOpen(true);
        setScroll("paper");
      };

      const descriptionElementRef = useRef<HTMLElement>(null);

      useEffect(()=>{
        setIsOpen(props.isOpen);
      });
    return (
    <>



        <Dialog
            open={isOpen}
            fullWidth={true}
            maxWidth={"md"}
            onBackdropClick={props.onCloseModal}
            scroll={scroll}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
        <DialogTitle id="scroll-dialog-title">{props.title}</DialogTitle>
        <DialogContent onClick={(e)=>{e.preventDefault();}} dividers={scroll === 'paper'}>
          <DialogContentText
            id="scroll-dialog-description"
            ref={descriptionElementRef}
            tabIndex={-1}
          >
            {props.message}
            &nbsp;
            {props.isShowSpinner ? <CircularProgress color="inherit" size={"1.3rem"} /> : ""}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>);
}

export default ProcessingModal;